<ng-container *ngrxLet="inputValue$ as inputValue">
	<textarea #textarea rows="1" autocomplete="on" autocorrect="on" spellcheck="off" [value]="value" [attr.maxlength]="maxlength"
			  (input)="onInput($event)" (focus)="onFocus()" (blur)="onBlur()"></textarea>
	@if (!inputValue) {
		<div class="placeholder no-events">{{ placeholder }}&nbsp;</div>
	}
	<div class="replica" aria-hidden="true">{{ inputValue }}&nbsp;</div>
</ng-container>